interface LightboxProps {
  type: 'image' | 'video';
  url: string;
  name: string;
  onClose: () => void;
  onSelect?: () => void;
  displaySelect?: boolean;
}

export default function Lightbox({
  type,
  url,
  name,
  onClose,
  onSelect,
  displaySelect = true,
}: LightboxProps) {
  return (
    <div className="fixed inset-0 z-50 bg-overlay backdrop-blur-sm">
      <div className="fixed inset-4 z-50 mx-auto max-w-[1000px] rounded-2xl border border-border/60 bg-card shadow-2xl p-4 grid grid-cols-[1fr_260px] gap-4 max-md:inset-2.5 max-md:rounded-none max-md:grid-cols-1">
        {type === 'image' ? (
          <img
            src={url}
            alt={name}
            className="w-full h-full max-h-full object-contain rounded-lg bg-black"
          />
        ) : (
          <video
            src={url}
            controls
            className="w-full h-full max-h-full object-contain rounded-lg bg-black"
          />
        )}
        <div className="grid gap-2.5 content-start max-h-full">
          <div className="font-bold break-words">{name}</div>
          {displaySelect && onSelect && (
            <button onClick={onSelect} className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover">
              Use this {type}
            </button>
          )}
          <button onClick={onClose} className="rounded-md border border-border/60 bg-card px-4 py-2 text-sm font-medium text-accent-foreground transition-colors hover:bg-secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
